import {
  calculateAmount,
  calculateArray,
} from "../../helper-payroll/HelperFunction";
export const getmodifiedTable = (args) => {
  const { newTableObject, isMultipleRows, isRemoved, mandatoryFormula, caseName, value } = args;
  if (!Array.isArray(newTableObject)) return [];

  console.log("valueArgs", value)

  console.log("isRemoved", isRemoved)

  return newTableObject.map((row, idx) => {
    const commonFields = [];
    const additionalFields = isMultipleRows
      ? [
          "overpaymentBasic",
          "overpaymentPeraAda",
          "tax",
          "excessAirportDuties",
          "OfDutyForCiaMciaBinocRangeTo1519",
          "OfDutyForCiaMciaBinocRangeTo15192",
          "pagibig",
          "phic",
          "apRate",
          "basicSalary",
          ...(caseName === "isSixthCase" ? ["basic"] : []),
          "overpayment",
          "flagRaising",
          "noOfDays",
          "3",
          "2",
          "5",
          "10",
        ]
      : [];

    const fieldsToExtend = [...additionalFields, ...commonFields];

    fieldsToExtend.forEach((field) => {
      if (!(field in row)) return;

      // Special handling for isTwelvethCase with apRate - keep as number, not array
      // const isTwelvethCaseApRate = caseName === "isTwelvethCase" && field === "apRate";

      // if (!isTwelvethCaseApRate && !Array.isArray(row[field])) {
      //   row[field] = [];
      // }

      const shouldCompute =
        commonFields.includes(field) && Array.isArray(row.basicRateForBackPay);

      if (shouldCompute) {
        const expression = mandatoryFormula[field] || "0";
        const { basicRateForBackPay, daysInAMonth, gsisInsuredDays } = row;
        const computedValues = row.basicRateForBackPay.map((rate) =>
          calculateAmount(expression, rate)
        );

        const gsis = calculateArray(basicRateForBackPay, [
          { type: "*", value: gsisInsuredDays },
          { type: "/", value: daysInAMonth },
          { type: "*", value: 0.09 },
        ]);

        row[field] = computedValues;
        row["gsisLR"] = gsis;
      } else if (isMultipleRows) {
        if (isRemoved) {
          // For isTwelvethCase with apRate, skip array removal logic
          // if (!isTwelvethCaseApRate) {
            // Sync array length with updatedCountPrd when removing
            // updatedCountPrd should already reflect the new count after removal
            const expectedLength = Array.isArray(row.updatedCountPrd) 
              ? row.updatedCountPrd.length 
              : (Array.isArray(row[field]) && row[field].length > 0 
                  ? Math.max(0, row[field].length - 1) 
                  : 0);

            
            if (!Array.isArray(row[field])) {
              row[field] = [];
            }
            
            const currentLength = row[field].length;
            
            // Remove excess items to match the new period count
            if (currentLength > expectedLength) {
              row[field] = row[field].slice(0, expectedLength);
            // }
          }
        } else {
          let defaultValue;

          if (
            field === "noOfDays" ||
            field === "OfDutyForCiaMciaBinocRangeTo1519"
          ) {
            defaultValue = 22;
          } 
          else if (field === "OfDutyForCiaMciaBinocRangeTo15192") {
            defaultValue = 15;
          }
          else if (field === "apRate") {
            defaultValue = row?.payCode ?? 0; // fallback to 0 if payCode is undefined
          } else if (field === "basicSalary") {
            defaultValue = row?.salary ?? 0;
          } else if (field === "basic" && caseName === "isSixthCase") {
            defaultValue = row?.salary ?? 0; // fallback to 0 if payCode is undefined
          } else {
            defaultValue = 0;
          }

          // For isTwelvethCase with apRate, set as number directly (not array)
          // if (isTwelvethCaseApRate) {
          //   row[field] = defaultValue;
          // } else {
            const expectedLength = Array.isArray(row.updatedCountPrd) 
              ? row.updatedCountPrd.length 
              : (Array.isArray(row[field]) && row[field].length > 0 
                  ? row[field].length 
                  : 1);

            if (!Array.isArray(row[field])) {
              row[field] = [];
            }
            
            const currentLength = row[field].length;
            
            if (currentLength < expectedLength) {
              const itemsToAdd = expectedLength - currentLength;

              for (let i = 0; i < itemsToAdd; i++) {
                row[field].push(defaultValue);
              }
            } else if (currentLength > expectedLength) {
              row[field] = row[field].slice(0, expectedLength);
            }
          // }
        }
      }

      if (!isMultipleRows && isRemoved) {
        const fieldsToCheck = [
          "overpaymentBasic",
          "overpaymentPeraAda",
          "tax",
          "pagibig",
          "phic",
          "OfDutyForCiaMciaBinocRangeTo1519",
          "OfDutyForCiaMciaBinocRangeTo15192",
          "overpayment",
          "flagRaising",
          "apRate",
          "basicSalary",
          "basic",
          "noOfDays",
          "3",
          "2",
          "5",
          "10",
        ];

        fieldsToCheck.forEach((fieldName) => {
          // Skip array logic for isTwelvethCase with apRate
          const isTwelvethCaseApRateField = caseName === "isTwelvethCase" && fieldName === "apRate";
          if (isTwelvethCaseApRateField) return;

          const currentArray = row[fieldName] ?? [];

          const isSpecial22 =
            fieldName === "noOfDays" ||
            fieldName === "OfDutyForCiaMciaBinocRangeTo1519";
          const isSpecial15 = fieldName === "OfDutyForCiaMciaBinocRangeTo15192";

          const isSpecialApRate = fieldName === "apRate";
          const isSpecialBasicSalary = fieldName === "basicSalary";

          const lastIndex = [...currentArray].reverse().findIndex((val) => {
            if (val === 0 || val === "") return true;

            if (isSpecial22 && val === 22) return true;
            if (isSpecial15 && val === 15) return true;

            if (isSpecialApRate && val === row?.payCode) return true;
            if (isSpecialBasicSalary && val === row?.salary) return true;

            return false;
          });

          if (lastIndex !== -1) {
            row[fieldName] = [];
          }
        });
      }
    });

    return row;
  });
};
